import { useModalContext } from "../../contexts/ModalContext";
import plus from "../../assets/images/svg/plus";

const OpenAddWishModalButton = () => {
  const { openAddWishModal } = useModalContext()

  const btnCss = "h-[15vh] w-1/2 global-px py-2 flexJustifyItemsCenter flex-col flex-wrap rounded-md text-darkRed text-center sm:w-1/4"
  const imgCss = "cursor-pointer transition ease-in-out scaleHover"

  const handleClick = (e) => {
    e.preventDefault()
    openAddWishModal()
  };

  return (
    <button className={btnCss} onClick={handleClick}>
      {plus(imgCss)}
    </button>
  )
}

export default OpenAddWishModalButton;
